import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const folderApi = createApi({
  reducerPath: 'folder',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['folders'],
  endpoints: (builder) => ({
    addFolder: builder.mutation({
      query: (data) => ({
        url: `category-dir`,
        method: 'POST',
        body: data,
      }),
    }),
    getFolders: builder.query({
      query: ({ id, limit }) => ({
        url: `category-dir/category/${id}?limit=${limit}`,
        method: 'GET',
      }),
    }),
    moveFolder: builder.mutation({
      query: (data) => ({
        url: `category-dir/folder/move`,
        method: 'PUT',
        body: data,
      }),
    }),
    shareFolder: builder.mutation({
      query: (data) => ({
        url: `category-dir/folder/share`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['folders'],
    }),
    renameFolder: builder.mutation({
      query: (data) => ({
        url: `category-dir/${data.id}/folder/rename?folder_name=${data.folder_name}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['folders'],
    }),
    getFolderByCategoryId: builder.query({
      query: (id) => ({
        url: `category-dir/category/${id}?limit=${1000}`,
        method: 'GET',
      }),
    }),
    deleteFolder: builder.mutation({
      query: (id) => ({
        url: `category-dir/${id}/folder/delete`,
        method: 'DELETE',
      }),
    }),
   

  }),
});

export const {
  useAddFolderMutation,
  useGetFoldersQuery,
  useMoveFolderMutation,
  useShareFolderMutation,
  useRenameFolderMutation,
  useGetFolderByCategoryIdQuery,
  useDeleteFolderMutation
} = folderApi;